import React from "react";

import { EmployeeSummary } from "@performyard/service-contracts";

import { BulletListSection } from "../components/BulletListSection";
import { StatCard, StatRow, StatRows } from "../components/StatCard";

export const FeedbackSection: React.FC<{ summary: EmployeeSummary }> = ({ summary }) => {
	const receivedCount = summary.signal_counts.feedback_received;
	const givenCount = summary.signal_counts.feedback_given;
	const stats = summary.feedback_stats;
	const insights = summary.feedback_insights;

	return (
		<div className="mt-1 flex flex-col gap-2">
			<div className="flex gap-2" data-testid="feedback-counts">
				<StatCard label="Feedback Activity" testId="feedback-stat-activity">
					<StatRows>
						<StatRow label="Received" value={receivedCount} testId="feedback-count-received" />
						<StatRow label="Given" value={givenCount} testId="feedback-count-given" />
					</StatRows>
				</StatCard>
				{stats !== null ? (
					<>
						<StatCard
							label="Unique Feedback Givers"
							value={stats.unique_givers}
							testId="feedback-stat-unique-givers"
						/>
						<StatCard label="Feedback Requested" testId="feedback-stat-requested">
							<StatRows>
								<StatRow
									label="Overall"
									value={stats.requested}
									testId="feedback-stat-requested-overall"
								/>
								<StatRow
									label="Response Rate"
									value={
										stats.requested_response_rate === null
											? "—"
											: `${Math.round(stats.requested_response_rate * 100)}%`
									}
									testId="feedback-stat-response-rate"
								/>
							</StatRows>
						</StatCard>
					</>
				) : null}
			</div>

			{insights !== null ? (
				<div className="flex flex-col gap-3" data-testid="feedback-insights">
					<BulletListSection title="Patterns" items={insights.patterns} testId="feedback-patterns" />
				</div>
			) : null}
		</div>
	);
};
